import React from 'react';
import { Card, Form, Space, Input } from 'antd';

import { formItemLayout } from '../Common';
import { isEmpty } from 'script/common';

const RedisAuth = ({t, settingKey, settingData, onSave}) => {
	const initialValues = {
		['data']: settingData
	}
	
	const onFinish = (e) => {
		let value = [];

		settingKey.keyList.map((list) => {
			let defaultValue = initialValues.data[list.value].default
			let	initValue = initialValues.data[list.value].value
			let setValue = e.data[list.value].value
			setValue = (defaultValue === setValue) ? null : setValue

			value.push({
				key: list.value,
				value: setValue
			})
		})

		if (!isEmpty(value)) {
			onSave(false, value)
		}
	}

	return (
		<Form {...formItemLayout} onFinish={onFinish} initialValues={initialValues}>
			<Card title={t(settingKey.key)} key={settingKey.key} style={{ margin: 20 }}>
				{settingKey.keyList.map((list) => {
					let isRequired = (list.value === 'redisPassword') ? false : true;
					return (
						<Form.Item
							key ={list.key}
							label={t(list.key)}
							name={['data', list.value, 'value']}
							rules={[{ required: isRequired, message: 'Please input value!' }]}
						>
							{ ((t(list.key)) === 'Password') ? <Input.Password  visibilityToggle={false}/> : <Input placeholder={settingData[list.value].default}/>}
						</Form.Item>
					)
				})}
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
		</Form>
		
	)
}

export default RedisAuth